import { ColDef } from 'ag-grid-community'

import { ProcessState } from '@flowx/core-sdk'
import { FlxActiveIncidentsComponent } from '@flowx/designer/modules/process/pages/processes/custom-table-cells/active-incidents.component'
import { ProcessUuidComponent } from '@flowx/designer/modules/process/pages/processes/custom-table-cells/process-uuid/process-uuid.component'
import { FlxDateCellComponent } from '@flowx/designer/shared/components/ag-grid/cell-components/date-cell.component'
import { FlxInstanceStatusComponent } from '@flowx/designer/shared/components/ag-grid/cell-components/instance-status.component'

export const PROCESS_INSTANCE_COLUMNS: ColDef[] = [
  {
    headerName: 'UUID',
    field: 'uuid',
    cellRenderer: ProcessUuidComponent,
    width: 160,
    flex: 0,
  },
  { headerName: 'Definition name', field: 'resourceName', minWidth: 120 },
  {
    headerName: 'Exceptions',
    field: 'activeIncidents',
    cellRenderer: FlxActiveIncidentsComponent,
    width: 104,
    flex: 0,
  },
  {
    headerName: 'Status',
    field: 'state',
    flex: 0,
    width: 130,
    cellRenderer: FlxInstanceStatusComponent,
  },
  {
    headerName: 'Current Node Name',
    field: 'node',
    minWidth: 145,
  },
  {
    headerName: 'Start date',
    field: 'dateStarted',
    cellRenderer: FlxDateCellComponent,
    width: 204,
    flex: 0,
  },
]

export const ProcessInstanceActiveStates = {
  [ProcessState.STARTED]: true,
  [ProcessState.ON_HOLD]: true,
}
